/* eslint-disable */

const paymentErrors = {
  niubiz: {
    '': {
      'group' : 'GENERIC',
      'title' : '¡Parece que algo salió mal!',
      'message' : 'Te pedimos disculpas por el inconveniente y solicitamos que vuelvas intentarlo en unos minutos.',
      'image' : 'generic'
    },
    'EI' : {
        'group' : 'ACTUALIZAR_DATOS',
        'title' : 'Email no válido!',
        'message' : 'Por favor, actualiza tu correo e intenta nuevamente.',
        'image' : '1'
    },
    '101' : {
        'group' : 'BANCO',
        'title' : '¡La tarjeta ingresada se encuentra vencida!',
        'message' : 'Por favor, inténtalo con otra tarjeta o comunícate con tu banco para mayor información.',
        'image' : '1'
    },
    '102' : {
        'group' : 'BANCO',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '104' : {
        'group' : 'BANCO',
        'title' : '¡La tarjeta ingresada no tiene autorización para realizar esta operación!',
        'message' : 'Por favor, inténtalo con otra tarjeta o comunícate con tu banco para mayor información.',
        'image' : '3'
    },
    '106' : {
        'group' : 'BANCO',
        'title' : '¡Has excedido la cantidad de intentos para ingresar tu contraseña!',
        'message' : '¡Has excedido la cantidad de intentos para ingresar tu contraseña!',
        'image' : '4'
    },
    '107' : {
        'group' : 'BANCO',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '108' : {
        'group' : 'BANCO',
        'title' : '¡Has excedido la cantidad de intentos permitidos para realizar esta operación!',
        'message' : 'Por favor, comunícate con tu banco para mayor información.',
        'image' : '4'
    },
    '109' : {
        'group' : 'BANCO',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '110' : {
        'group' : 'BANCO',
        'title' : '¡La tarjeta ingresada no tiene autorización para realizar esta operación!',
        'message' : 'Por favor, inténtalo con otra tarjeta o comunícate con tu banco para mayor información.',
        'image' : '3'
    },
    '111' : {
        'group' : 'BANCO',
        'title' : '¡No hemos podido procesar la operación!',
        'message' : 'El monto supera el máximo de transacción para operaciones virtuales. \nPor favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '112' : {
        'group' : 'REINTENTAR',
        'title' : '¡La contraseña ingresada es incorrecta!',
        'message' : 'Por favor, inténtalo nuevamente.',
        'image' : '5'
    },
    '113' : {
        'group' : 'MONTO_INVALIDO',
        'title' : '¡Oops algo salió mal!',
        'message' : 'No se pudo realizar el proceso, el importe no está permitido.',
        'image' : '6'
    },
    '116' : {
        'group' : 'FONDOS_INSUFICIENTES',
        'title' : '¡Tu tarjeta tiene fondos insuficientes!',
        'message' : 'Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '117' : {
        'group' : 'BANCO',
        'title' : '¡La contraseña ingresada es incorrecta!',
        'message' : 'Por favor, intenta nuevamente o comunícate con tu banco para mayor información.',
        'image' : '7'
    },
    '118' : {
        'group' : 'BANCO',
        'title' : '¡La tarjeta ingresada no es válida!',
        'message' : 'Por favor, comunícate con tu banco para mayor información.',
        'image' : '8'
    },
    '119' : {
        'group' : 'BANCO',
        'title' : '¡Has excedido la cantidad de intentos para ingresar tu contraseña!',
        'message' : 'Por favor, comunícate con tu banco para mayor información',
        'image' : '7'
    },
    '121' : {
        'group' : 'BANCO',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '126' : {
        'group' : 'BANCO',
        'title' : '¡La contraseña ingresada es incorrecta!',
        'message' : 'Por favor, intenta nuevamente o comunícate con tu banco para mayor información.',
        'image' : '7'
    },
    '129' : {
        'group' : 'BANCO',
        'title' : '¡La tarjeta ingresada no es válida!',
        'message' : 'Por favor, comunícate con tu banco para mayor información.',
        'image' : '8'
    },
    '151' : {
        'group' : 'BANCO',
        'title' : '¡La tarjeta ingresada se encuentra cancelada!',
        'message' : 'Por favor, comunícate con tu banco para mayor información.',
        'image' : '3'
    },
    '161' : {
        'group' : 'REPORTAR',
        'title' : '¡La tarjeta ingresada no es válida!',
        'message' : 'Por favor, comunícate con tu banco para mayor información.',
        'image' : '8'
    },
    '180' : {
        'group' : 'BANCO',
        'title' : '¡La tarjeta ingresada no es válida!',
        'message' : 'Por favor, comunícate con tu banco para mayor información.',
        'image' : '8'
    },
    '181' : {
        'group' : 'BANCO',
        'title' : '¡La tarjeta ingresada no es válida!',
        'message' : 'Por favor, comunícate con tu banco para mayor información.',
        'image' : '8'
    },
    '182' : {
        'group' : 'BANCO',
        'title' : '¡La tarjeta ingresada no es válida!',
        'message' : 'Por favor, comunícate con tu banco para mayor información.',
        'image' : '8'
    },
    '183' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '190' : {
        'group' : 'BANCO',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '191' : {
        'group' : 'BANCO',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '192' : {
        'group' : 'BANCO',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '199' : {
        'group' : 'BANCO',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '201' : {
        'group' : 'BANCO',
        'title' : '¡La tarjeta ingresada se encuentra vencida!',
        'message' : 'Por favor, inténtalo con otra tarjeta o comunícate con tu banco para mayor información.',
        'image' : '1'
    },
    '202' : {
        'group' : 'BANCO',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '204' : {
        'group' : 'BANCO',
        'title' : '¡La tarjeta ingresada no tiene autorización para realizar esta operación!',
        'message' : 'Por favor, inténtalo con otra tarjeta o comunícate con tu banco para mayor información.',
        'image' : '3'
    },
    '206' : {
        'group' : 'BANCO',
        'title' : '¡Has excedido la cantidad de intentos para ingresar tu contraseña!',
        'message' : '¡Has excedido la cantidad de intentos para ingresar tu contraseña!',
        'image' : '4'
    },
    '207' : {
        'group' : 'BANCO',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '208' : {
        'group' : 'BANCO',
        'title' : '¡La tarjeta ingresada no tiene autorización para realizar esta operación!',
        'message' : 'Por favor, inténtalo con otra tarjeta o comunícate con tu banco para mayor información.',
        'image' : '3'
    },
    '209' : {
        'group' : 'BANCO',
        'title' : '¡La tarjeta ingresada no tiene autorización para realizar esta operación!',
        'message' : 'Por favor, inténtalo con otra tarjeta o comunícate con tu banco para mayor información.',
        'image' : '3'
    },
    '263' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '264' : {
        'group' : 'REINTENTAR',
        'title' : '¡El banco emisor no se encuentra disponible en estos momentos!',
        'message' : 'Por favor, comunícate nuevamente en unos minutos.',
        'image' : '9'
    },
    '265' : {
        'group' : 'BANCO',
        'title' : '¡La contraseña ingresada es incorrecta!',
        'message' : 'Por favor, inténtalo nuevamente.',
        'image' : '5'
    },
    '266' : {
        'group' : 'BANCO',
        'title' : '¡La tarjeta ingresada se encuentra vencida!',
        'message' : 'Por favor, inténtalo con otra tarjeta o comunícate con tu banco para mayor información.',
        'image' : '1'
    },
    '280' : {
        'group' : 'BANCO',
        'title' : '¡La contraseña ingresada es incorrecta!',
        'message' : 'Por favor, inténtalo nuevamente.',
        'image' : '5'
    },
    '282' : {
        'group' : 'BANCO',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '283' : {
        'group' : 'BANCO',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '290' : {
        'group' : 'BANCO',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '300' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '306' : {
        'group' : 'BANCO',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '310' : {
        'group' : 'BANCO',
        'title' : '¡Tu tarjeta fue reportada como pérdida!',
        'message' : 'Por favor, comunícate con tu banco para mayor información.',
        'image' : '10'
    },
    '311' : {
        'group' : 'BANCO',
        'title' : '¡Tu tarjeta fue reportada como robada!',
        'message' : 'Por favor, comunícate con tu banco para mayor información.',
        'image' : '10'
    },
    '312' : {
        'group' : 'BANCO',
        'title' : '¡La tarjeta ingresada se encuentra vencida!',
        'message' : 'Por favor, inténtalo con otra tarjeta o comunícate con tu banco para mayor información.',
        'image' : '1'
    },
    '313' : {
        'group' : 'BANCO',
        'title' : '¡La tarjeta ingresada se encuentra bloqueada!',
        'message' : 'Por favor, inténtalo con otra tarjeta o comunícate con tu banco para mayor información.',
        'image' : '3'
    },
    '314' : {
        'group' : 'BANCO',
        'title' : '¡La tarjeta ingresada se encuentra bloqueada!',
        'message' : 'Por favor, inténtalo con otra tarjeta o comunícate con tu banco para mayor información.',
        'image' : '3'
    },
    '315' : {
        'group' : 'BANCO',
        'title' : '¡Tu tarjeta fue reportada como robada!',
        'message' : 'Por favor, comunícate con tu banco para mayor información.',
        'image' : '10'
    },
    '316' : {
        'group' : 'BANCO',
        'title' : '¡La tarjeta ingresada no existe!',
        'message' : 'Por favor, inténtalo con otra tarjeta o comunícate con tu banco para mayor información.',
        'image' : '10'
    },
    '317' : {
        'group' : 'BANCO',
        'title' : '¡La tarjeta ingresada se encuentra bloqueada!',
        'message' : 'Por favor, inténtalo con otra tarjeta o comunícate con tu banco para mayor información.',
        'image' : '3'
    },
    '319' : {
        'group' : 'INTERNO',
        'title' : '¡Tu tarjeta tiene fondos insuficientes!',
        'message' : 'Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '320' : {
        'group' : 'LISTA_NEGRA',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '401' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '403' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '404' : {
        'group' : 'REPORTAR',
        'title' : '¡Tu tarjeta tiene fondos insuficientes!',
        'message' : 'Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '405' : {
        'group' : 'MAXIMOS_INTENTOS',
        'title' : '¡Tu tarjeta ha superado la cantidad de compras máximas permitidas en el día!',
        'message' : 'Por favor, intenta nuevamente con otra tarjeta o comunícate con tu banco para mayor información.',
        'image' : '6'
    },
    '406' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '407' : {
        'group' : 'POSTERGAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '420' : {
        'group' : 'SOLO_VISA',
        'title' : '¡La tarjeta ingresada debe ser Visa!',
        'message' : 'Recuerda que solo puedes realizar pagos con esta tarjeta.',
        'image' : '1'
    },
    '421' : {
        'group' : 'BANCO',
        'title' : '¡Tu tarjeta fue reportada como riesgosa!',
        'message' : 'Por favor, comunícate con tu banco para mayor información.',
        'image' : '4'
    },
    '423' : {
        'group' : 'REINTENTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '424' : {
        'group' : 'BANCO',
        'title' : '¡Tu tarjeta fue reportada como riesgosa!',
        'message' : 'Por favor, comunícate con tu banco para mayor información.',
        'image' : '4'
    },
    '426' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '427' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '428' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '429' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '430' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '431' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '432' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '433' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '434' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '435' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '436' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '437' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '438' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '439' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '440' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '441' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '442' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '443' : {
        'group' : 'DATOS_INVALIDOS',
        'title' : '¡Los datos ingresados de tu tarjeta son inválidos!',
        'message' : 'Por favor, ingresa el mes y el año de expiración de tu tarjeta de crédito correctamente.',
        'image' : '11'
    },
    '444' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '445' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '446' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '447' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '448' : {
        'group' : 'MAXIMAS_CUOTAS',
        'title' : '¡El número de cuotas ingresado no es válido!',
        'message' : 'Recuerda que debes ingresar un número entero menor a 36.',
        'image' : '4'
    },
    '449' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '450' : {
        'group' : 'DATOS_INVALIDOS',
        'title' : '¡La tarjeta ingresada no es válida!',
        'message' : 'Por favor, comunícate con tu banco para mayor información.',
        'image' : '8'
    },
    '451' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '452' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '453' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '454' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '455' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '456' : {
        'group' : 'MONTO_INVALIDO',
        'title' : '¡El monto no ha sido ingresado!',
        'message' : 'Por favor, intenta nuevamente.',
        'image' : '10'
    },
    '457' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '458' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '459' : {
        'group' : 'DATOS_INVALIDOS',
        'title' : '¡La tarjeta ingresada no es válida!',
        'message' : 'Por favor, inténtelo nuevamente o comunícate con tu banco para mayor información.',
        'image' : '8'
    },
    '460' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '461' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '462' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '463' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '464' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '465' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '466' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '467' : {
        'group' : 'DATOS_INVALIDOS',
        'title' : '¡El código “CVC” ingresado es inválido!',
        'message' : 'Recuerda que el código CVC es un número entero de 3 o 4 dígitos. Si no logras visualizarlo, comunícate con tu banco.',
        'image' : '12'
    },
    '468' : {
        'group' : 'DATOS_INVALIDOS',
        'title' : '¡El código “CVC” ingresado es inválido!',
        'message' : 'Recuerda que el código CVC es un número entero de 3 o 4 dígitos. Si no logras visualizarlo, comunícate con tu banco.',
        'image' : '12'
    },
    '469' : {
        'group' : 'REPORTAR',
        'title' : '¡El tipo de fecha es inválido!',
        'message' : 'Recuerda que el formato debe ser mes y año (MMAA).',
        'image' : '13'
    },
    '470' : {
        'group' : 'MONTO_INVALIDO',
        'title' : '¡El monto ingresado es inválido!',
        'message' : 'Recuerda que solo debes ingresar números y punto decimal.',
        'image' : '14'
    },
    '471' : {
        'group' : 'MONTO_INVALIDO',
        'title' : '¡El monto ingresado es inválido!',
        'message' : 'Recuerda que solo debes ingresar números y punto decimal.',
        'image' : '14'
    },
    '472' : {
        'group' : 'MAXIMAS_CUOTAS',
        'title' : '¡El número de cuotas ingresado no es válido!',
        'message' : 'Recuerda que debes ingresar un número entero menor a 36.',
        'image' : '4'
    },
    '473' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '474' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '475' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '476' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '477' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '478' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '479' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '480' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '481' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '482' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '483' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '484' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '485' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '486' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '487' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '488' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '489' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '490' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '491' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '492' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '493' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '494' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '495' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '496' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '497' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '498' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '619' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '666' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '667' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '668' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '670' : {
        'group' : 'LISTA_BLANCA',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, vuelve a intentarlo en 12 horas.',
        'image' : '2'
    },
    '672' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '673' : {
        'group' : 'REINTENTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, vuelve a intentarlo más tarde.',
        'image' : '2'
    },
    '674' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '675' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '678' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '680' : {
        'group' : 'BANCO',
        'title' : '¡Has excedido la cantidad de intentos para ingresar tu contraseña!',
        'message' : '¡Has excedido la cantidad de intentos para ingresar tu contraseña!',
        'image' : '4'
    },
    '682' : {
        'group' : 'REINTENTAR',
        'title' : '¡La fecha de pago se encuentra vencida!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '11'
    },
    '683' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '684' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '685' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '690' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '691' : {
        'group' : 'REPORTAR',
        'title' : '¡La tarjeta ingresada no es válida!',
        'message' : 'Por favor, comunícate con tu banco para mayor información.',
        'image' : '8'
    },
    '692' : {
        'group' : 'REPORTAR',
        'title' : '¡La tarjeta ingresada se encuentra vencida!',
        'message' : 'Por favor, inténtalo con otra tarjeta o comunícate con tu banco para mayor información.',
        'image' : '1'
    },
    '754' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '904' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, vuelve a intentarlo más tarde.',
        'image' : '2'
    },
    '909' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, vuelve a intentarlo más tarde.',
        'image' : '2'
    },
    '910' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, vuelve a intentarlo más tarde.',
        'image' : '2'
    },
    '912' : {
        'group' : 'BANCO',
        'title' : '¡El banco emisor no se encuentra disponible en estos momentos!',
        'message' : 'Por favor, comunícate nuevamente en unos minutos.',
        'image' : '9'
    },
    '913' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '916' : {
        'group' : 'BANCO',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '928' : {
        'group' : 'BANCO',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '940' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '941' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '942' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '943' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '945' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '946' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '947' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '948' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '949' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    },
    '965' : {
        'group' : 'REPORTAR',
        'title' : '¡Lo sentimos!',
        'message' : 'No hemos podido procesar la operación. Por favor, comunícate con tu banco para mayor información.',
        'image' : '2'
    }
  },
}


export default paymentErrors



// WEBPACK FOOTER //
// ./src/interfaces/paymentErrors.js